// src/beta/components/CoverageScorecard.tsx
import { ScoreBars } from '@/beta/components/ScoreBars';
import type { V1Verification } from '@/beta/types/dossier';

interface Props {
  verification: V1Verification;
}

/** § 6.4 (2): Coverage scorecard.
 *  - <ScoreBars> renders each of the 7 parts with a horizontal bar.
 *  - "Next wins" list shows the top 3 actions with +N% delta in VM red. */
export function CoverageScorecard({ verification }: Props) {
  const wins = verification.next_wins.slice(0, 3);

  return (
    <div>
      <ScoreBars parts={verification.parts} />

      <div style={{ marginTop: 'var(--vm-s-3)' }}>
        <h3
          style={{
            fontFamily: 'var(--vm-font-heading)',
            fontSize: 11,
            letterSpacing: '0.3em',
            textTransform: 'uppercase',
            color: 'var(--vm-stone)',
            margin: 0,
            marginBottom: 'var(--vm-s-2)',
          }}
        >
          Next wins
        </h3>

        {wins.length === 0 ? (
          <p style={{ color: 'var(--vm-stone)', fontSize: 13, fontFamily: 'var(--vm-font-body)' }}>
            No outstanding wins — coverage is fully documented.
          </p>
        ) : (
          <ul style={{ listStyle: 'none', margin: 0, padding: 0 }}>
            {wins.map((w, i) => (
              <li
                key={i}
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  padding: 'var(--vm-s-1) 0',
                  borderBottom: '1px solid var(--vm-border)',
                  color: 'var(--vm-warm-white)',
                  fontFamily: 'var(--vm-font-body)',
                  fontSize: 13,
                }}
              >
                <span>{w.action}</span>
                <span style={{ color: 'var(--vm-red)', fontFamily: 'var(--vm-font-heading)', letterSpacing: '0.1em' }}>
                  +{w.delta}%
                </span>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}
